<template>
  <div>
    <PageHeader />
    <ProjInfo :projectInfo="projectInfo" />

        <v-container class="section-block">

            <v-row>
                <v-col class="col-12 col-md-8">
                   
                </v-col>
            </v-row>

           
        </v-container>

  </div>
</template>

<script>


export default {
    name: 'dotkit',
    components: {
        // PageHeader,
        // ProjInfo,
        // InstallInfo,
    },
    data: () => ({
        images: {
            poster: require('../assets/images/DotkitPoster.jpg'),
            transitions: require('../assets/images/Dotkit_transtions.png'),
            newLayer: require('../assets/images/Dotkit-NewLayer.jpg'),
            addState: require('../assets/images/Dotkit-AddState.jpg'),
            removeNearest: require('../assets/images/Dotkit-RemoveNearest.jpg'),
        },
        projectInfo: {
            name: 'Analytics',
            subtitle: 'Tracking all the goods',
            source: true,
            // download: '/download/DotKit_1.2.zip',
            // version: '2.0',
            // updated: 'Sep 7, 2021',
            // about: `This is 2.0 of the universally loved <a href="dotkit-v1">DotKit v1</a> with some major updates.

            // Expressions and precomps have been replaced with a single shape layer and a dynamic keyframing system. This reduces render time in a big way, improves flexibility to using the dots like a normal layer, and adds support for <a href="https://airbnb.design/lottie/">Lottie</a>.`
        },
        changelog: [
            {
                version: '2.0.1',
                date: 'Sept 17, 2021',
                added: [
                    'Dot rotation thinking state',
                ],
                changed: [
                    'Renamed Molecule sine wave to Molecule Thinking',
                    'Smooth out Molecule Thinking transitions'
                ]
            },
            {
                version: '2.0.0',
                date: 'Sept 7, 2021',
                comment: [
                    'Initial release',
                ],
            },
        ],
        dotStates: {
            states: [
                'Listening',
                'Thinking',
                'User_input',
                'Mic',
                'Molecule',
                'Molecule_Thinking',
                'Super_G',
            ],
            'automatic transitions': [
                'Listening_to_thinking',
                'Listening_to_user_input',
                'Listening_to_mic',
                'Listening_to_molecule_thinking',
                'Listening_to_molecule',
                'User_input_to_Mic',
                'User_input_to_Molecule',
                'Molecule_to_thinking',
                'Thinking_to_molecule_thinking',
                'Listening_to_G',
                'Molecule_to_G',
            ],
            'no transition': [
                'Molecule_to_mic',
                'Mic_to_G',
            ],
        }
    }),
    filters: {
        uppercase(str) {
            return str.toUpperCase()
        },
        removeUnderscores(str) {
            return str.replace(/_/g, ' ')
        },
    }
}
</script>

<style scoped>
/* .state-box {
    background: #fff;
    margin: 16px 12px;
    padding: 16px 0;
}
.state-box h3 {
    padding-left: 16px;
} */
.state-box img {
    border: 1px solid rgba(0,0,0,0.03);
}
.state-box .col {
    margin-bottom: 18px;
}
.state-box h2 {
    /* margin-bottom: -54px; */
}

</style>